// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"834":"227084b1","907":"21f29bce"}[chunkId] + ".css";
};